import { useState } from "react";
import { Link } from "react-router-dom";

// Ikon sederhana sebagai pengganti dari gambar Anda.
// Anda bisa menggantinya dengan SVG kustom Anda sendiri.
const ConfirmationIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-20 w-20 text-indigo-500 mx-auto"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={1}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
    d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15 3a2 2 0 11-4 0 2 2 0 014 0zM15 9a2 2 0 11-4 0 2 2 0 014 0zM15 15a2 2 0 11-4 0 2 2 0 014 0zM15 21a2 2 0 11-4 0 2 2 0 014 0z"
    />
  </svg>
);

export default function CertificateFormPage() {
  // State untuk mengontrol tampilan mana yang muncul: form atau konfirmasi
  const [isSubmitted, setIsSubmitted] = useState(false);

  // State untuk menyimpan data form (opsional, tapi praktik yang baik)
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault(); // Mencegah reload halaman saat form disubmit

    // Di sini Anda bisa menambahkan logika pengiriman data ke server
    console.log("Data yang dikirim:", { name, email });

    // Ubah state untuk menampilkan halaman konfirmasi
    setIsSubmitted(true);
  };

  const handleReset = () => {
    // Kembali ke tampilan form
    setIsSubmitted(false);
    // Kosongkan kembali input
    setName("");
    setEmail("");
  };

  return (
    // Kontainer utama untuk menengahkan konten dan memberi background gradasi
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-cyan-50 via-white to-green-100">
      <div className="w-full max-w-lg p-8 space-y-8 text-center">
        {isSubmitted ? (
          // === TAMPILAN SETELAH SUBMIT ===
          <div>
            <ConfirmationIcon />
            <h2 className="mt-6 text-3xl font-bold text-gray-900">
              Thanks for confirming!
            </h2>
            <p className="mt-2 text-base text-gray-600">
              Your request is being processed and will be completed within 3
              business days. Hang tight!
            </p>
            <div className="mt-8">
              <Link to={"/dashboard"}>
                <div
                  //   onClick={handleReset}
                  className="w-full px-6 py-3 text-sm font-semibold text-white bg-[#2D224E] rounded-lg shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 cursor-pointer"
                >
                  Go to The Dashboard
                </div>
              </Link>
            </div>
          </div>
        ) : (
          // === TAMPILAN FORMULIR AWAL ===
          <div>
            <h2 className="text-3xl font-bold text-gray-900">
              You're all set!
            </h2>
            <p className="mt-2 text-sm text-gray-600">
              Just fill in your name and email so we can send your certificate.
            </p>
            <form className="mt-8 space-y-6 text-left" onSubmit={handleSubmit}>
              <div>
                <label
                  htmlFor="name"
                  className="block text-sm font-medium text-gray-700"
                >
                  Name
                </label>
                <div className="mt-1">
                  <input
                    id="name"
                    name="name"
                    type="text"
                    required
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Enter Your Name"
                    className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:outline-none"
                  />
                </div>
              </div>

              <div>
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-700"
                >
                  Email
                </label>
                <div className="mt-1">
                  <input
                    id="email"
                    name="email"
                    type="email"
                    autoComplete="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter Your Email"
                    className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:outline-none"
                  />
                </div>
              </div>

              <div>
                <button
                  type="submit"
                  className="w-fit px-6 py-3 text-sm font-semibold text-white bg-indigo-600 rounded-lg shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  Send
                </button>
              </div>
            </form>
          </div>
        )}
      </div>
    </div>
  );
}
